export enum StorageKeys {
    API_KEY = 'apiKey',
    AUTH_TOKEN = 'authToken',
    REALM = 'realm',
    REFRESH_TOKEN = 'refresh'
}
